<template>
    <div class="foot">
        <div :class="['menu','flex','flex-start','flex-col',activeMenu==index?'on':'']" v-for="(item,index) in menuList" :key="index" @click="select(index,item.haveChild,item.url)">
            <div :class="['child',item.showChild?'on':'']" v-if="item.haveChild">
                <router-link :to="childItem.url" tag="div" class="childMenu" v-for="(childItem,childIndex) in item.children" :key="childIndex" @click.prevent.stop="pushChild(childItem.url,index)">{{childItem.name}}</router-link>
            </div>
            <div class="icon">
                <img :src="activeMenu==index?item.active_icon:item.icon" alt="菜单图标">
                <div :class="[item.num > 0 ? 'right-top': 'on']" v-show="item.num!=0">{{judge(item.num)}}</div>
            </div>
            <span>{{item.name}}</span>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return {
             menuList:[
                {
                    name: '课程',
                    icon: './static/images/1_1/footer_course.png',
                    active_icon: './static/images/1_1/footer_course_on.png',
                    // children:[
                    //     {
                    //         name: '课程表',
                    //         url: '/student/course/schedule'
                    //     },
                    //     {
                    //         name: '我的课程',
                    //         url: '/student/course/list'
                    //     }
                    // ],
				    url: '/student/course/list',
                    num: 0,    //右上角红点或者数量  超过  99 显示 99+
                },
                {
                    name: '消息',
                    icon: './static/images/1_1/footer_msg.png',
                    active_icon: './static/images/1_1/footer_msg_on.png',
                    url: '/student/msg/list-new',
                    num: this.$store.getters.getUnReadNum,    //右上角红点或者数量  大于0小于等于 99  正常显示
                },
                {
                    name: '我的',
                    icon: './static/images/1_1/footer_mine.png',
                    active_icon: './static/images/1_1/footer_mine_on.png',
                    url: '/student/user/center',
                    num: 0,    //右上角红点或者数量  小于0，显示红点
                }
            ],
            showAll: false,   //点击其他菜单是否显示别的子菜单
            activeMenu: 0,
            paths: {},   // 存储路由对应 索引
        }
    },
    watch:{
        $route(to,from,next){
          if (this.$route.meta.keepAlive) {
            this.loadUnReadMsg();
          }
            if(this.$route.path.indexOf('/student/course') > -1){
                this.activeMenu = 0;
                return;
            }
            this.activeMenu = this.paths[this.$route.path];
        },

    },
    methods:{
        judge(num){
            return num > 99 ? "99+" : num > 0 ? num : '';
        },
        select(index,child,url){
           var canJump = false;
           var item = this.menuList[index].showChild;
            if(child){    //如果存在子菜单  显示或隐藏子菜单
                if(!this.showAll){
                     this.hideChildMenu(index);
                }
                this.menuList[index].showChild = !item;
                this.$forceUpdate();
            }else{
                if(!this.showAll){
                     this.hideChildMenu(index);
                }
                if(index != this.activeMenu){
                    this.$router.replace(url);
                }
            }
       },
       hideChildMenu(index){
            for(var menuIndex in this.menuList){
                let target = this.menuList[menuIndex];
                if(menuIndex != index){
                    target.showChild = false;
                }
            }
            this.$forceUpdate();
       },
        pushChild(url,index){
            console.log(url);
            this.menuList[index].showChild = false;
            this.$forceUpdate();
       },

        //dosomething
        loadUnReadMsg(){
            var _this = this;
            this.$axios.post(this.stuApiUrl + "/sys/msg/search",
            this.$qs.stringify({
                pageNo: 1,
                pageSize: 10,
                typeStr: -1
            })).then(function(res){
                _this.$store.commit("setUnReadNum",res.data.unRead);
                _this.menuList[1].num = _this.$store.getters.getUnReadNum;
                console.log(_this.menuList[1].num);
            })
        },


    },
    created(){
        console.log(this.menuList)
        for(let index in this.menuList){
            let item = this.menuList[index];
            if(item.children){
                item.haveChild = true;
                item.showChild = false;
                for(var childIndex in item.children){
                    var childItem = item.children[childIndex];
                    this.paths[childItem.url] = index;
                }
            }else{
                item.haveChild = false;
                this.paths[item.url] = index;
            }
            console.log(index);
        }
        console.log(this.paths);
        console.log(this.$route.path)
        if(this.$route.path.indexOf('/student/course') > -1){
            this.activeMenu = 0;
            return;
        }
        this.activeMenu = this.paths[this.$route.path];
    },
    mounted(){
        this.loadUnReadMsg();
        var _this = this;
        this.$bus.$on('readMsg',(data)=>{
            _this.menuList[1].num = data;
            console.log(_this.menuList[1].num);
        });
    },

}
</script>
<style scoped>
    .foot{
        width: 100%;
        height: 1rem;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #EDEEF2;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        transform: translateY(0rem);
        transition: all 0.5s;
    }
    .foot.hide{
        transform: translateY(1rem);
    }
    .menu{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .menu:first-child:nth-last-child(2),
	.menu:first-child:nth-last-child(2) ~ .menu{
        width: 50%;
	}
	.menu:first-child:nth-last-child(3),
	.menu:first-child:nth-last-child(3) ~ .menu{
        width: 33.3%;
    }
    .menu:first-child:nth-last-child(4),
	.menu:first-child:nth-last-child(4) ~ .menu{
        width: 25%;
    }
    .menu:first-child:nth-last-child(5),
	.menu:first-child:nth-last-child(5) ~ .menu{
        width: 20%;
    }
    .menu::after{
        content: '';
        width: 1px;
        height: 0.6rem;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -0.3rem;
        background: #e9e9e9;
    }
    .menu:last-child::after{
        content: none;
    }
    .menu.on{
        color: #03bbb5;
    }
    .menu .child.on{
        height: auto;
        display: block;
    }
    .menu .child{
        width: 100%;
        position: absolute;
        bottom: 1rem;
        left: 0;
        display: none;
        height: 0;
        border: 1px solid #ccc;
        background: #fff;
        border-radius: .05rem;
    }
    .menu .child div.childMenu{
        width: 80%;
        margin: 0 auto;
        height: 1rem;
        font-size: 0.28rem;
        line-height: 1rem;
        color: #b8bacc;
        border-bottom: 1px solid #ccc;
     }
    .menu .child div.childMenu:last-child{
        border: none;
    }
    .menu .child div.active{
       color: #03bbb5;
    }
    .menu .icon{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }
    .menu .icon img{
        width: 0.4rem;
        height: 0.4rem;
        margin-top: 0.1rem;
    }
    .menu .icon .right-top{
        padding: 0 0.1rem;
        line-height: 0.34rem;
        min-width: 0.5rem;
        position: absolute;
        top: 2px;
        left: 50%;
        margin-left: 0.25rem;
        border-radius: 0.17rem;
        background: #F8544B;
        color: #fff;
        font-size: 0.24rem;
    }
    .menu .icon .on{
        width: 0.2rem;
        height: 0.2rem;
        position: absolute;
        border-radius: 0.1rem;
        top: 50%;
        left: 50%;
        margin-left: 0.2rem;
        margin-top: -0.2rem;
        background: #EA5454;
    }
    .menu span{
        font-size: 0.24rem;
        width: 100%;
        text-align: center;
        display: block;
        margin-top: .04rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/student/include/footer-syx.vue